<mat-progress-bar
  mode="indeterminate"
  class="progress-bar"
  *ngIf="progressBarService.showProgressBar$ | async"
  @fadeInOut
></mat-progress-bar>
